import { render, staticRenderFns } from "./checklist-in-task-modal.vue?vue&type=template&id=3d8ba8de&scoped=true"
import script from "./checklist-in-task-modal.vue?vue&type=script&lang=js"
export * from "./checklist-in-task-modal.vue?vue&type=script&lang=js"
import style0 from "./checklist-in-task-modal.vue?vue&type=style&index=0&id=3d8ba8de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ba8de",
  null
  
)

export default component.exports